export default __webpack_public_path__ + "static/media/howPosterityWorks.aef729ab.jpg";